<template>
  <Dialog v-model="model" fullscreen>
    <template #title> Details {{ item.first_name }} {{ item.last_name }} </template>
    <template #activator="{ on }">
      <ActionButton icon="mdi-eye" color="pink" v-on="on"> Details </ActionButton>
    </template>
    <v-card-text class="text--primary">
      <v-container :id="item.uuid">
        <v-row>
          <v-col
            v-for="({ text, value, separator, textClass }, index) in data"
            :key="text + index"
            cols="12"
            :sm="separator ? 12 : 6"
            :md="separator ? 12 : 4"
            :lg="separator ? 12 : 3"
          >
            <template v-if="separator">
              <div class="title">
                {{ text }}
              </div>
              <v-divider />
            </template>
            <template v-else>
              <div class="caption font-weight-bold">
                {{ text }}
              </div>
              <div class="pink--text body-1" style="white-space: pre-line" :class="textClass">
                {{ value }}
              </div>
            </template>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn class="white--text ml-auto mr-4" color="pink" @click="onPrint">
        Print
        <v-icon right> mdi-printer </v-icon>
      </v-btn>
    </v-card-actions>
  </Dialog>
</template>
<script>
import Dialog from "../Dialog.vue";
import ActionButton from "./ActionButton.vue";
import { observationsController } from "../../api/crm";
import jsPdf from "jspdf";

export default {
  components: { ActionButton, Dialog },
  props: {
    item: { type: Object, required: true },
    value: Boolean,
  },
  data() {
    return {
      model: this.value,
      weekdays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      observations: [],
      hasBeenOpened: false,
    };
  },
  methods: {
    onPrint() {
      let pdfName = "Contact Details - " + new Date().toLocaleString();
      var doc = new jsPdf();
      doc.fromHTML(document.querySelector(`#${this.item.uuid}`), 15, 15, {
        width: 170,
      });
      doc.save(pdfName + ".pdf");
    },
  },
  computed: {
    data() {
      const data = [
        { text: "Student's Generals", value: "Info", separator: true },
        { text: "Student's Name", value: this.item.full_name },
        { text: "Email", value: this.item.email },
        { text: "Phone", value: this.item.phone },
        { text: "Location", value: this.item.location },
        { text: "Nationality", value: this.item.nationality },
        {
          text: "Marketing Source",
          value: this.item.marketing_source || "",
        },
        {
          text: "Status",
          value: String(this.item.status || "").toLowerCase(),
          textClass: "text-capitalize",
        },
        { text: "Academics", value: "Placement Test", separator: true },
        {
          text: "Appointment for Test",
          value: this.item.appointment ?? "",
        },
        {
          text: "Starting Level",
          value: this.item.starting_level || "",
        },
        {
          text: "Availability",
          value: this.item.availability_text || "",
        },
        { text: "Program", value: this.item.program || "" },
        { text: "Teacher", value: this.item.teacher || "" },
        { text: "Schedule", value: this.item.leveling_test_data?.schedule || "" },
        { text: "Starting Date", value: this.item.leveling_test_data?.starting_date ?? "" },
        { text: "Observations", value: "Observations", separator: true },
        {
          text: "Observations",
          value: this.item.leveling_test_data?.observations || "",
        },
      ].filter((item) => item.separator || !!item.value);
      return data;
    },
  },
  watch: {
    async model(value) {
      this.$emit("input", value);
      if (!this.hasBeenOpened && value) {
        const response = await observationsController.getter({
          limit: 100,
          contact__uuid: this.item.uuid,
        });
        this.observations = response.data.results.sort((a, b) => a.date > b.date);
        this.hasBeenOpened = true;
      }
    },
    value(value) {
      this.model = value;
    },
  },
};
</script>
